const isSmoothScrollSupported = "scrollBehavior" in document.documentElement.style;
export const smoothScroll = (elem, { top, left }) => {
    if (isSmoothScrollSupported) {
        elem.scrollTo({ top, left, behavior: "smooth" });
        return;
    }
    elem.scrollTo(top, left);
};
